import domWrap from "./domWrap";
import h from "./htm";

let stack = 0;

export default (content,ready = () => {},done = ()=>{}, className = '') => {
	document.querySelector('#modal-lightbox')?.remove();

	document.body.appendChild(h(`div id="modal-lightbox" class="modal ${className}"`,
		h('div class="modal-content"',
			h('div style="min-height: 200px;"',content)
			('button class="close"','')
		)
	).Node);

	const lightbox = domWrap(document.querySelector('#modal-lightbox'));

	lightbox.on('click','.close',function  (e) {
		if(done){
			done();
		}
		closeModal(lightbox,{complete(){}});
	});

	openModal(lightbox, {
			dismissible: true, // Modal can be dismissed by clicking outside of the modal
			in_duration: 300, // Transition in duration
			out_duration: 200, // Transition out duration
			ready(){
				ready();
				document.querySelector('body > .lean-overlay').addEventListener('click',() => {
					if(done){
						done();
					}
				});
			},
			complete() { 
				done();
				lightbox.remove();
			}
		}
	);
};

function openModal(modal, {
		opacity = 0.5,
		in_duration = 350,
		out_duration = 250,
		ready = undefined,
		complete = undefined,
		dismissible = true,
		starting_top = '4%',
		ending_top = '10%'
	} = {}) {

	const 	body = domWrap(document.body),
			overlay = domWrap(h('div class="lean-overlay"').Node),
			lStack = stack;

	body.style.width = window.getComputedStyle(body, 'width') + 'px';
	body.css({'overflow': 'hidden'});
	overlay.css({'zIndex' : 1000 + lStack * 2});

	if (modal.classList.contains('open')) return;
	
	modal
		.data('overlay', overlay)
		.css({'zIndex': 1000 + lStack * 2 + 1})
		.classList.add('open');

	body.appendChild(overlay);


	if (dismissible) {
		overlay.addEventListener('click',() => {
			closeModal(modal, {
				out_duration,
				starting_top,
				complete
			});
		});
	}


	modal.on('click', '.modal-close', function(e) {
		closeModal(modal, {
			out_duration,
			starting_top,
			complete
		});
	});

	const baseCSS = {display: "block", opacity: 0, transitionDuration: `${in_duration}ms`};
	overlay.css(baseCSS);
	modal.css({...baseCSS, top: starting_top, scaleX: 0.7});
	modal.data('associated-overlay', overlay);

	setTimeout(()=> {
		overlay.css({opacity: opacity});
		modal.css({top: ending_top, opacity: 1, scaleX: '1'});
		ready();
	},50);
}


function closeModal(modal, {
	out_duration= 250,
	complete= undefined,
	starting_top = '4%',
} = {}) {

	const overlay = modal.data('overlay');
	modal.classList.remove('open');

	// Enable scrolling
	domWrap(document.body).css({
	  overflow: '',
	  width: ''
	});

	overlay.css( { transitionDuration: `{out_duration}ms`});

	setTimeout(()=>{
		overlay.css( { opacity: 0});
		modal.css({ top: starting_top, opacity: 0, scaleX: 0.7});
		setTimeout(()=> {
			modal.css({display: 'none'});
			complete();
			overlay.remove();
			stack--;
		},out_duration);
	},50);
}
